import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  ReferenceLine,
  Cell,
} from "recharts";

const colors = {
  chart: {
    driver: "#04aade", // Blue for positive impact
  },
  text: {
    dark: "#065f46",
    medium: "#10b981",
  },
  accent: "#e5e7eb",
};

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    const value = payload[0].value || 0;
    return (
      <div
        style={{
          backgroundColor: "white",
          padding: "0.75rem",
          border: "1px solid #e5e7eb",
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          borderRadius: "4px",
        }}
      >
        <p style={{ margin: 0, fontWeight: 500, color: "#374151" }}>{label}</p>
        <p style={{ margin: 0, fontSize: "0.875rem", color: "#4B5563" }}>
          {`Impact: ${value.toFixed(4)}`}
        </p>
      </div>
    );
  }
  return null;
};

const formatYAxisTick = (value) => {
  return typeof value === "number" ? Number(value.toFixed(4)) : value;
};

const SmallMultipleDriverChart = ({ location, data, minYAxis, maxYAxis }) => {
  // Determine the highest positive value among the data for a reference (optional)
  const highestPositive = data.reduce(
    (acc, curr) => (curr.value > acc ? curr.value : acc),
    0
  );
  return (
    <div
      style={{
        maxWidth: 400,
        width: "100%",
        border: "1px solid #e5e7eb",
        padding: "16px",
        borderRadius: "8px",
        background: "#fff",
      }}
    >
      <div style={{ textAlign: "center", marginBottom: "2px" }}>
        <h3
          style={{
            color: colors.text.dark,
            borderBottom: `1px solid ${colors.accent}`,
            paddingBottom: "0.1rem",
            margin: 0,
            fontSize: "16px",
          }}
        >
          {location}
        </h3>
      </div>
      <ResponsiveContainer width="100%" height={200}>
        <BarChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 50 }}>
          <CartesianGrid strokeDasharray="3 3" opacity={0.2} stroke={colors.accent} />
          <XAxis
            dataKey="driver"
            tick={{
              fontSize: 10,
              fill: colors.text.medium,
              angle: -45,
              textAnchor: "end",
              dx: -5,
            }}
            interval={0}
            axisLine={{ stroke: colors.accent }}
          />
          <YAxis
            domain={[minYAxis, maxYAxis]}
            tick={{ fontSize: 10, fill: colors.text.medium }}
            tickLine={false}
            axisLine={false}
            tickFormatter={formatYAxisTick}
          />
          <Tooltip content={<CustomTooltip />} />
          <Bar dataKey="value" barSize={20}>
            {data.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={entry.value >= 0 ? "#04aade" : "#F59694"}
              />
            ))}
          </Bar>
          {/* Add a baseline reference line at 0 */}
          <ReferenceLine
            y={0}
            stroke="#000"
            strokeDasharray="3 3"
            label={{
              value: "0",
              position: "insideLeft",
              fontSize: 10,
              fill: "#000",
            }}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default SmallMultipleDriverChart;
